import { useMemo } from "react";
import { buildPopularSearchItems } from "./popular-search-data";
import { usePopularSearchCache } from "./use-popular-search-cache";

export const usePopularSearches = ({
  searchInFocus,
  mobileOverlayOpen,
  frequentSearches,
  trendingPostTerms,
}) => {
  const { popularSearches, popularSearchesFetchFailed } =
    usePopularSearchCache({
      searchInFocus,
      mobileOverlayOpen,
    });

  const popularItems = useMemo(
    () =>
      buildPopularSearchItems({
        popularSearches,
        frequentSearches,
        trendingPostTerms,
        popularSearchesFetchFailed,
      }),
    [
      popularSearches,
      frequentSearches,
      trendingPostTerms,
      popularSearchesFetchFailed,
    ]
  );

  const popularUpdatedAt = useMemo(
    () =>
      new Intl.DateTimeFormat("ko-KR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
        .format(new Date())
        .replace(/\. /g, ".")
        .replace(".", ".")
        .trim(),
    []
  );

  return {
    popularItems,
    popularUpdatedAt,
  };
};
